import PropTypes from "prop-types";
import LineChart from "./LineChart";

function EvolucionFuncionariosChart({ data, period, customDates }) {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <LineChart
          data={data}
          period={period}
          customDates={customDates}
          title="Evolución Temporal de Atenciones por Funcionario"
          height={400}
          legendPosition="right"
          showFilter={true}
          filterLabel="Funcionarios"
          defaultSelectedCount={4}
          stepSize={20}
          tension={0.4}
          useConsistentColors={false}
        />
      </div>
    </div>
  );
}

EvolucionFuncionariosChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string),
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.number),
      })
    ),
  }),
  period: PropTypes.string,
  customDates: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default EvolucionFuncionariosChart;
